"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var elog = require("@reverbdotcom/commons/dist/elog");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var redirectTimeoutMs = 2000;
var TAG = 'adyen.threeds1_container';
var ThreeDS1Container = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeDS1Container, _super);
    function ThreeDS1Container() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeDS1Container.prototype.componentDidMount = function () {
        tracker_1.trackView({ componentName: 'ThreeDS1Container' });
        elog.info(TAG + ".mount");
        setTimeout(this.props.submitForm.bind(this), redirectTimeoutMs);
    };
    ThreeDS1Container.prototype.renderAlert = function () {
        if (!this.props.show3ds1AlertBox) {
            return null;
        }
        return (React.createElement("h1", { className: "align-center alert-box alert-box--blue" }, I18n.t('discovery.coreOnboarding.beingRedirectedFor3ds')));
    };
    ThreeDS1Container.prototype.render = function () {
        var _this = this;
        return (React.createElement("form", { action: this.props.redirectUrl, method: "POST", ref: function (el) { _this.formRef = el; } },
            this.renderAlert(),
            React.createElement("input", { type: "hidden", name: "PaReq", value: this.props.paReq }),
            React.createElement("input", { type: "hidden", name: "MD", value: this.props.md }),
            React.createElement("input", { type: "hidden", name: "TermUrl", value: this.props.termUrl })));
    };
    ThreeDS1Container.defaultProps = {
        show3ds1AlertBox: true,
        submitForm: function () {
            this.formRef.submit();
        },
    };
    return ThreeDS1Container;
}(React.Component));
exports.default = ThreeDS1Container;
//# sourceMappingURL=threeds1_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds1_container.js
// module id = 30Fg
// module chunks = 20 21 22